import { axios } from '@/utils/request'

// 首页统计
export function getIndexStatistics(parameter) {
  return axios({
    url: '/merchant.php/Index/index',
    method: 'get',
    params: parameter
  })
}

// 预加载
export function getPagesPre(parameter) {
  return axios({
    url: '/merchant.php/Page/pre',
    method: 'get',
    params: parameter
  })
}

// 页面管理 - 页面列表
export function getPagesList(parameter) {
  return axios({
    url: '/merchant.php/Page/getList',
    method: 'get',
    params: parameter
  })
}

// 页面管理 - 页面详情
export function getPagesDetail(parameter) {
  return axios({
    url: '/merchant.php/Page/detail',
    method: 'get',
    params: parameter
  })
}

// 页面管理 - 新增页面
export function postPagesAdd(data) {
  return axios({
    url: '/merchant.php/Page/add',
    method: 'post',
    data: data
  })
}

// 页面管理 - 编辑页面
export function postPagesEdit(data) {
  return axios({
    url: '/merchant.php/Page/edit',
    method: 'post',
    data: data
  })
}

// 页面管理 - 删除页面
export function postPagessDel(data) {
  return axios({
    url: '/merchant.php/Page/del',
    method: 'post',
    data: data
  })
}

// 复制页面
export function postCopyPage(data) {
  return axios({
    url: '/merchant.php/Page/copyPage',
    method: 'post',
    data: data
  })
}
